export function submitForm(payload: any, callback: any, openInSameTab: boolean = false) {
  let startedDate = new Date();
  if (openInSameTab && payload?.submitUrl) {
    const form = document.createElement('form');
    form.style.display = 'none';
    form.method = "post";
    form.action = payload?.submitUrl;
    let parameters = ["Parameter1", "Parameter2", "Parameter3"];
    for (const params of parameters) {
      if (!payload?.hasOwnProperty(params.toLowerCase())) {
        return;
      }
      let input = document.createElement('input');
      input.name = params;
      input.id = params;
      input.value = payload[params.toLowerCase()];
      input.defaultValue = payload[params.toLowerCase()];
      form.appendChild(input);
    }
    document.body.appendChild(form);
    form.submit(); 
    return;
  }

  let popupWinHeight = 650;
  let popupWinWidth = 1200;
  let left = (screen.width - popupWinWidth) / 2;
  let top = (screen.height - popupWinHeight) / 4;
  let myWindow = 'width=' + popupWinWidth + ', height=' + popupWinHeight + ', top='
    + top + ', left=' + left;
  let newWindow = window.open('', "_blank", myWindow+',resizable=yes,location=yes,scrollbars=yes,status=yes');
  if(!newWindow){
    return;
  }
  const form = newWindow.document?.createElement('form');
  form.style.display = 'none';
  form.method = "post";
  form.action = payload?.submitUrl;
  let parameters = ["Parameter1", "Parameter2", "Parameter3"];
  for(const params of parameters){
    if (!payload?.hasOwnProperty(params.toLowerCase())) {
    return
    }
    let input = newWindow.document.createElement('input');
    input.name = params;
    input.id = params;
    input.value = payload[params.toLowerCase()];
    input.defaultValue = payload[params.toLowerCase()];
    form.appendChild(input);
  }
  newWindow.document.body.appendChild(form);
  form.submit();
  if(!newWindow){
    return;
  }
  let interVal = setInterval(function () {
    try{
      timeInterval(newWindow, startedDate, interVal, callback);
    }catch (ex){
      console.error('Failed:', ex);
      if (newWindow?.closed || !newWindow) {
        callback({message: "Closing window timeout!"});
        clearInterval(interVal);
        return;
      }
    }
  }, 2000);
}
 
export function timeInterval(newWindow: any, startedDate: any, interVal: any, callback: any) {
  let diffMilliSeconds = Date.now() - startedDate.valueOf();
  if (newWindow?.location?.host === location.host) {
    let params = (new URL(newWindow?.location?.href)).searchParams;
    callback(null, params.get('id'));
    newWindow.close();
    clearInterval(interVal);
  }
  if((((diffMilliSeconds/(1000*60*15)) > 1) && newWindow) || !newWindow){
    newWindow?.close();
    callback({message: "Closing window timeout!"});
    clearInterval(interVal);
  }
}
